import questionAssembly from './src'
questionAssembly.install = (Vue) => {
  Vue.component(questionAssembly.name, questionAssembly)
}
export default questionAssembly



// WEBPACK FOOTER //
// ./packages/question-assembly/index.js